var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.8332 6.96086L16.0341 8.75916L11.2374 3.9625L13.0357 2.16329C13.3539 1.84519 13.7854 1.66656 14.2353 1.66656C14.6852 1.66656 15.1167 1.84519 15.4349 2.16329L17.8332 4.56166C18.1513 4.87984 18.3301 5.31129 18.3301 5.76121C18.3301 6.21112 18.1513 6.64268 17.8332 6.96086ZM3.07239 18.2767L8.23905 16.5542L3.44239 11.7575L1.71989 16.9242C1.65669 17.1128 1.64742 17.3156 1.69314 17.5092C1.73884 17.703 1.83773 17.8801 1.97864 18.0207C2.11955 18.1612 2.2969 18.2596 2.49073 18.3048C2.68454 18.3501 2.88714 18.3403 3.07572 18.2767H3.07239Z",
    fill: "#5D78FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64491 17.75L3.07658 18.2733C2.88817 18.336 2.68603 18.3451 2.49278 18.2995C2.29953 18.2538 2.12278 18.1553 1.98233 18.0149C1.84188 17.8746 1.74326 17.6979 1.6975 17.5047C1.65174 17.3114 1.66065 17.1093 1.72323 16.9209L2.24658 15.3517L4.64491 17.75ZM3.44573 11.7542L8.24241 16.5508L16.0374 8.75584L11.2407 3.95915L3.44573 11.7542Z",
    fill: "#5D78FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.265995258d57fc903e3145d436a0cd36.svg";
export { ForwardRef as ReactComponent };